<div class="hpanel search-page-navbar-stickyyy gs-card">
  <div class="panel-body border-radius-top-left-right-6 gs-card-body">
    <div class="mainNav">
      <!-- Result count, matching the Business listing header. userTotalCount is the
           total number of matches, not the number of cards loaded so far, so it
           does not climb as the page scrolls. -->
      <div class="navIteam">
        <h6>People : <span> {{userTotalCount}}</span></h6>
      </div>
      <div class="navIteam">
          <input type="text" class="form-control pd-lt-10 search-field-pad" (keyup)="peopleData($event)" [formControl]="clearInput"
            name="searchadmin" id="searchadmin" placeholder="Search people" />
          <ng-icon name="tablerSearch" class="pos-ab"></ng-icon>
          <!-- <span class="input-group-addon"><ng-icon name="tablerSearch"></ng-icon></span>
          <span class="input-group-addon" (click)="clearData()"><ng-icon name="tablerX"></ng-icon></span> -->
      </div>
      <!-- <div class="navIteam connectionbtn"> -->
        <!-- <div class="btn-group" dropdown> -->
          <!-- <button id="button-animated" dropdownToggle type="button" class="btn    dropdown-toggle fbtn"
            aria-controls="dropdown-animated"> -->
            <!-- <span class="mr-5"><img src="assets/icon/icons8-mail-filter-96.png" alt="" srcset=""
                class="filimg" /></span>Filter -->
          <!-- </button> -->
        <!-- </div> -->
      <!-- </div> -->
      <div class="navIteam">
        <button class="btn primary-btn">Advance Search</button>
      </div>
    </div>
  </div>
</div>

<div class="search-content-layout">
  <!-- infiniteScroll sits on the feed itself: it is the flex grid, so the
       cards must stay its direct children (a wrapper div collapses the grid). -->
  <div class="search-content-feed pad-people-60610" infiniteScroll [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="300" [scrollWindow]="true" (scrolled)="onScroll()">
    <!-- Skeleton grid while the results fetch is in flight -->
    <ng-container *ngIf="isLoading">
      <div class="col-md-4 sCard pad-right-5" *ngFor="let c of loaderCards">
        <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
      </div>
    </ng-container>
    <ng-container *ngIf="!isLoading">
      <div class="col-md-4 sCard pad-right-5" *ngFor="let item of allpost">
        <app-user-card (handleEvent)="handleUserCardEvent($event)" [userDataInput]="item" [standard]="true"></app-user-card>
      </div>
      <!-- Next page in flight -->
      <ng-container *ngIf="isLoadingMore">
        <div class="col-md-4 sCard pad-right-5" *ngFor="let c of loadMoreCards">
          <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
        </div>
      </ng-container>
      <!-- Search came back with nothing. Uses the same app-nodata-found empty
           state as the rest of the app (connections, team members, community
           members) so People / Business / All all read identically instead of
           leaving a blank panel under the result count. -->
      <div class="col-sm-12" *ngIf="allpost.length === 0 && !isLoadingMore">
        <app-nodata-found screen="SEARCH" [title]="['No results found']" [buttonShow]="false">
        </app-nodata-found>
      </div>
      <div class="col-sm-12" *ngIf="!hasMore && !isLoadingMore && allpost.length > 0"
        style="text-align: center; padding: 1.5rem 0; color: #777;">
        <ng-icon name="tablerCircleCheck"></ng-icon>
        <p class="biase">You've reached the bottom of the page</p>
      </div>
    </ng-container>
  </div>
  <div class="search-content-widget search-page-mr-tp-10">
    <app-common-widget [page]="'NETWORK_PAGE'" [inputData]="'NETWORK'"></app-common-widget>
  </div>
</div>
